import React from 'react';
import styled from 'styled-components';

import { ArticleDescription, ArticleHeader } from '@components/atoms';

type ArticleProps = {
  title: string;
  description?: string;
  titleMaxWidth?: string;
  descriptionMaxWidth?: string;
  align?: 'left' | 'right' | 'center';
  wrapAlign?: 'center' | 'flex-end' | 'flex-start';
  margin?: string;
  wrapWidth: string;
};

function Article({
  title,
  align,
  titleMaxWidth,
  description,
  wrapWidth,
  wrapAlign,
  descriptionMaxWidth,
  margin,
}: ArticleProps) {
  return (
    <DescriptionWrapper
      $width={wrapWidth}
      $wrapAlignItems={wrapAlign}
      $margin={margin}
    >
      <ArticleHeader
        title={title}
        align={align}
        titleMaxWidth={titleMaxWidth}
      />

      {description && (
        <ArticleDescription
          description={description}
          align={align}
          descriptionMaxWidth={descriptionMaxWidth}
        />
      )}
    </DescriptionWrapper>
  );
}

const DescriptionWrapper = styled.article<{
  $width: string;
  $margin?: string;
  $wrapAlignItems?: string;
}>`
  width: ${({ $width }) => $width};
  margin: ${({ $margin }) => $margin};

  display: flex;
  flex-direction: column;
  justify-content: center;

  align-items: ${({ $wrapAlignItems }) => $wrapAlignItems};
`;

export default Article;
